import { useEasyStepRowBlockData } from './useEasyStepRowBlockData';
import EasyStepBlock from '../EasyStepBlock/EasyStepBlock';

interface EasyStepRowBlockProps {
	index: number;
	rowTitle: string;
	listOfSteps: number[];
	contentLink: {
		id: string;
		guidValue: string;
	};
}

export const EasyStepRowBlock = ({
	index,
	listOfSteps,
	rowTitle,
	contentLink,
}: EasyStepRowBlockProps) => {
	const data = useEasyStepRowBlockData(contentLink.id);

	const calculateStartIndexDependsOnRow = (startIndexForStep: number) => {
		let startIndex = startIndexForStep;
		for (let i = 0; i < index; i++) {
			startIndex += listOfSteps[i];
		}
		return startIndex;
	};

	const getGridClassForCurrentStepNumber = () =>
		listOfSteps[index] === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2';

	return (
		<>
			<div className="container mb-24">
				<h3 className="text-2xl">{rowTitle}</h3>
			</div>
			<div
				className={`container grid grid-cols-1 ${getGridClassForCurrentStepNumber()} gap-16 md:gap-8 mb-24`}
			>
				{data?.steps.map((card, i) => {
					return (
						<EasyStepBlock
							key={i}
							index={calculateStartIndexDependsOnRow(i)}
							{...card}
						/>
					);
				})}
			</div>
		</>
	);
};
